import React from 'react';

function Loading() {
  return (
      <>
          <div className="loader spinner-center" style={{display: 'flex', justifyContent: 'center'}}>
              <i className="fa fa-spinner fa-spin fa-5x" />
              <span className="pt-2 ml-2"></span>
          </div>
      </>
  );
}

export default Loading;